module.exports = __webpack_public_path__ + "static/media/00_insideyourblood.cb7b9166.jpg";